var forOf = require('./_for-of');

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_array-from-iterable.js
// module id = 56
// module chunks = 0